import React from "react";
import motoAsset from "../assets/zuno/zuno-moto.webp";
import goAsset from "../assets/zuno/zuno-go.webp";
import eliteAsset from "../assets/zuno/zuno-elite.webp";
import activityAsset from "../assets/zuno/activity-empty.webp";

const vehicleAssets = {
  moto: motoAsset,
  go: goAsset,
  movel: goAsset,
  comfort: eliteAsset,
  elite: eliteAsset,
};

const vehicleLabels = {
  moto: "Zuno Moto",
  go: "Zuno Go",
  movel: "Zuno Go",
  comfort: "Zuno Elite",
  elite: "Zuno Elite",
};

export function ZunoVehicle({ type = "go", className = "", title }) {
  const asset = vehicleAssets[type] || goAsset;
  const label = title || vehicleLabels[type] || "Zuno Go";

  return (
    <img
      className={`zuno-vehicle-asset ${className}`.trim()}
      src={asset}
      alt={label}
      draggable="false"
    />
  );
}

export function EmptyRideVisual() {
  return (
    <img
      className="zuno-empty-ride-asset"
      src={activityAsset}
      alt="Rota Zuno ainda sem corridas"
      draggable="false"
    />
  );
}
